module.exports = __webpack_public_path__ + "3a88ce615f44f884ee87bdec504bc79e.pdf";